<template>
  <div class="c-breadcrumb">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div :style="{ color: breadcrumbColor }">
        <div class="c-breadcrumb-content">
          <ul class="c-breadcrumb__navs" v-if="navs?.length > 0">
            <li v-for="(nav, index) in navs" :key="index">
              <div v-if="!nav?.isLink || index === navs?.length - 1">{{ nav?.title }}</div>
              <site-link
                v-else
                :link="{ value: { href: nav?.url, linktype: 'internal', text: nav?.title } }"
                data-event_name="breadcrumb_click"
              />
              <icon name="right" v-if="index < navs?.length - 1" />
            </li>
          </ul>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted, getCurrentInstance } from 'vue';

export default {
  name: 'BreadcrumbNavigation',
  props: {
    fields: {
      type: Object,
    },
    page: {
      type: Object,
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const state = reactive({
      navs: [],
    });

    const breadcrumbColor = props?.page?.fields?.BreadcrumbFontColor?.value || '';

    onMounted(async () => {
      const instance = getCurrentInstance();
      const $jss = instance.appContext.config.globalProperties.$jss;
      const sitecoreContext = $jss.sitecoreContext();
      state.navs = sitecoreContext.breadcrumbs ?? [];
    });

    return {
      ...toRefs(state),
      breadcrumbColor,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';
.c-breadcrumb {
  position: absolute;
  top: 54px;
  z-index: 10;
  width: 100%;
  height: 46px;
  background: transparent;
  color: $white;
  @include h7;
  display: none;
  &.white {
    color: $white;
  }
  &.black {
    color: $black;
  }
  .e-icon svg {
    fill: currentColor;
  }
  &__home-icon {
    display: flex;
    align-items: center;
    height: 46px;
    line-height: 46px;
  }
  &__buttons {
    display: flex;
    align-items: center;
    gap: $space-8;
  }
  &__navs {
    display: flex;
    align-items: center;
    flex-grow: 1;
    > li {
      display: flex;
      align-items: center;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      .e-icon {
        position: relative;
        display: flex;
        align-items: center;
        margin: 0 $space-8;
        width: 12px;
        height: 12px;
        svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  &__back-top {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  &__back-title {
    display: none;
  }
  @media (min-width: 1100px) {
    display: block;
    top: 68px;
    &__content {
      @include grid-block(3, 20);
    }
    height: 46px;
    &__back-top {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    &__back-title {
      display: block;
      white-space: nowrap;
    }
  }
}
</style>
